import cx from 'classnames'

import TinyEditorModal from '../TinyEditorModal'
import UISelect from 'components/shared/UISelect'
import UserSelect from 'components/UserSelect'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import './style.styl'

export const EmailSenderTypes = {
  STATIC: 'static',
  DYNAMIC: 'dynamic',
}

export const EmailFormatTypes = {
  FIRST_LAST: 'FIRST_LAST',
  FIRST_ONLY: 'FIRST_ONLY',
  FIRST_WITH_ORG: 'FIRST_WITH_ORG',
  FIRST_LAST_WITH_ORG: 'FIRST_LAST_WITH_ORG',
}

// TODO: remove this logic in place of using the displayName property once we implement it
const getUserFirstName = (user) => (user.name || '').split(' ')[0]

const StaticEmailSenderSelect = ({
  onUserIdChange,
  selectedOption,
  onStaticSendNameChange,
  staticSendName,
  staticSendEmail,
  defaultUser,
  renderSelectedUser,
  includeInboxEmails = true,
}) => (
  <div className="edit-email-sender-user-select">
    <div className="edit-email-sender-modal-heading">Sender Name &amp; Email</div>
    <div className="edit-email-sender-modal-form">
      <div className="drift-form">
        <input type="text" value={staticSendName || defaultUser.name} onChange={onStaticSendNameChange} placeholder={'Sender name'} />
      </div>
      <UserSelect
        selectedUserId={selectedOption || defaultUser.id}
        onUserIdChange={onUserIdChange}
        renderOption={user => (!!user.name ? `${user.email} (${user.name})` : user.email)}
        renderSelectedValue={renderSelectedUser}
        includeInboxEmails={includeInboxEmails}
      />
    </div>
  </div>
)

const DynamicEmailSenderSelect = ({
  onUserIdChange,
  selectedOption,
  onStaticSendNameChange,
  onFormatSelect,
  staticSendName,
  renderSelectedUser,
  formatType,
  exampleUser,
  org,
  defaultUser,
  includeInboxEmails = true,
}) => (
  <div>
    <div>
      <div className="edit-email-sender-modal-heading">Set Formatting</div>
      <div className="edit-email-sender-modal-form">
        <form className="drift-form">
          <div className="edit-email-sender-format-option">
            <input type="radio" name="formatting" id="first-last-formatting" onClick={() => onFormatSelect(EmailFormatTypes.FIRST_LAST)} checked={formatType === EmailFormatTypes.FIRST_LAST}/>
            <label htmlFor="first-last-formatting">
              <p className="edit-email-sender-format-example">{exampleUser.name} &lt;{exampleUser.email}&gt;</p>
              <small className="edit-email-sender-format-label">Full name</small>
            </label>
          </div>
          <div className="edit-email-sender-format-option">
            <input type="radio" name="formatting" id="first-only-formatting" onClick={() => onFormatSelect(EmailFormatTypes.FIRST_ONLY)} checked={formatType === EmailFormatTypes.FIRST_ONLY}/>
            <label htmlFor="first-only-formatting">
              <p className="edit-email-sender-format-example">{getUserFirstName(exampleUser)} &lt;{exampleUser.email}&gt;</p>
              <small className="edit-email-sender-format-label">First name</small>
            </label>
          </div>
          <div className="edit-email-sender-format-option">
            <input type="radio" name="formatting" id="first-with-org-formatting" onClick={() => onFormatSelect(EmailFormatTypes.FIRST_WITH_ORG)} checked={formatType === EmailFormatTypes.FIRST_WITH_ORG}/>
            <label htmlFor="first-with-org-formatting">
              <p className="edit-email-sender-format-example">{getUserFirstName(exampleUser)} from {org.name}</p>
              <small className="edit-email-sender-format-label">First name &amp; company</small>
            </label>
          </div>
        </form>
      </div>
    </div>
    <div className="edit-email-sender-user-select">
      <div className="edit-email-sender-modal-heading">As a fallback, send from:</div>
      <div className="edit-email-sender-modal-form">
        <div className="drift-form">
          <input type="text" value={staticSendName || defaultUser.name} onChange={onStaticSendNameChange} placeholder={'Sender name'} />
        </div>
        <UserSelect
          selectedUserId={selectedOption || defaultUser.id}
          onUserIdChange={onUserIdChange}
          renderOption={user => (!!user.name ? `${user.email} (${user.name})` : user.email)}
          renderSelectedValue={renderSelectedUser}
          includeInboxEmails={includeInboxEmails}
        />
      </div>
    </div>
  </div>
)

const SenderSelect = ({
  senderChoices,
  onSenderTypeSelect,
  selectedSenderChoice,
}) => (
  <div>
    <div className="edit-email-sender-modal-heading">Send From</div>
    <div className="edit-email-sender-modal-form">
      <UISelect
        options={senderChoices}
        value={selectedSenderChoice}
        onChange={onSenderTypeSelect}
      />
    </div>
  </div>
)

export const EmailEditSenderModal = ({ selectedSenderType, hideModal, onSave, ...rest }) => (
  <TinyEditorModal title={"Sender Details"} onClose={hideModal} long={selectedSenderType === EmailSenderTypes.DYNAMIC}>
    <div className="edit-email-sender-modal-content-container">
      <div className="edit-email-sender-modal">
        <SenderSelect {...rest} />
        {selectedSenderType === EmailSenderTypes.STATIC && <StaticEmailSenderSelect {...rest} />}
        {selectedSenderType === EmailSenderTypes.DYNAMIC && <DynamicEmailSenderSelect {...rest} />}
      </div>
      <div className="edit-email-sender-modal-footer">
        <button className="edit-email-sender-footer-button drift-button drift-button-primary" onClick={onSave}>
          Save
        </button>
        <button className="edit-email-sender-footer-button drift-button" onClick={hideModal}>
          Cancel
        </button>
      </div>
    </div>
  </TinyEditorModal>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailEditSenderModal/component.js